import { render, staticRenderFns } from "./EditBookingSummarySidebar.vue?vue&type=template&id=dc10e7f6"
import script from "./EditBookingSummarySidebar.vue?vue&type=script&lang=js"
export * from "./EditBookingSummarySidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports